/** @jsx jsx */
import { jsx } from "@emotion/core"
import { Typography } from "antd"
import PropTypes from "prop-types"
import { textStyles } from "./styles"
const { Text } = Typography

/**
- Standard Text component for displaying textual user information/messages.
- Based on top of Antd [typography](https://ant.design/components/typography/), This component accepts all of antd typography props and more.
**/
export const TextTag = (props) => {
  const { textType, ...rest } = props
  return (
    <Text {...rest} css={textStyles(textType)}>
      {props.children}
    </Text>
  )
}

TextTag.propTypes = {
  /** default - for input field texts
   * tagline - to be used for app tagline, eg Homepage
   * taglineBold - to make the tagline bold, eg JOMO
   * spaceName - space name between the couple
   * pageHeading - at all the pages which gives description about the page, eg kitchen text
   * bodyHeading - to show the information regarding the page content and user information of his search.
   * sectionHeading - Restaurant names, any section title
   * placeHolder - placeholder of input
   * sectionTextPrimary - subheading or info below the page heading
   * sectionTextSecondary - dish names, menu description, eg Mediterranean, Indian, Seafood
   * linkText - all link or anchor tag
   * smallTextPrimary - bottom text in a section or info regarding next step, eg you will be able to continue on your mobile browser.
   * smallTextSecondary - address below space names or couple 123 Long Street, City, ST 20005  **/
  /** The type of the text */
  textType: PropTypes.oneOf([
    "default",
    "tagline",
    "taglineBold",
    "spaceName",
    "pageHeading",
    "bodyHeading",
    "sectionHeading",
    "placeHolder",
    "sectionTextPrimary",
    "sectionTextSecondary",
    "linkText",
    "smallTextPrimary",
    "smallTextSecondary",
  ]),

  /** span/styled text content */
  children: PropTypes.node,
}

TextTag.defaultProps = {
  textType: "default",
}
